import React, { useState, useEffect, useRef } from 'react';
import { ZIM } from "zego-zim-web";
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Peer from "simple-peer";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import useRedirectLoggedOutUser from "../customHook/useRedirectLoggedOutUser";
import {
  getLoginStatus, getUser, selectIsLoggedIn, selectUser, RESET, getCalendarData, getByDefaultUsers,
} from "../redux/features/auth/authSlice";
import Sidebar from "../components/Sidebar";
import {
  getConversations,
  updateMessagesAndConversations,
  markMessagesAsSeen,
} from "../redux/features/chat/chatSlice";
import KbmChatHome from "../components/chat/KbmChatHome";
import ChatContainer from "../components/chat/ChatContainer";
import SocketContext from "../context/SocketContext";
import Call from "../components/chat/call/Call";
import {
  getConversationId,
  getConversationName,
  getConversationPicture,
} from "../utils/chat";
import axios from 'axios';

// const callData = {
//   socketId: "",
//   receiveingCall: false,
//   callEnded: false,
//   name: "",
//   picture: "",
//   signal: "",
// };

// const socket = io.connect(process.env.REACT_APP_BACKEND_URL);
const callUrl = process.env.REACT_APP_BACKEND_URL;
const appID = Number(process.env.REACT_APP_ID_ZEGO);
const serverSecret = process.env.REACT_APP_SECRET_KEY_ZEGO;

function randomID(len) {
  let result = '';
  if (result) return result;
  var chars = '12345qwertyuiopasdfgh67890jklmnbvcxzMNBVCZXASDQWERTYHGFUIOLKJP',
    maxPos = chars.length,
    i;
  len = len || 5;
  for (i = 0; i < len; i++) {
    result += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return result;
}

const Home = ({ socket }) => {

  useRedirectLoggedOutUser('/login')

  // console.log(socket);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { user, users, shiftBookings } = useSelector((state) => state.auth);
  // const user = useSelector(selectUser);
  const { activeConversation } = useSelector((state) => state.chat);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [typing, setTyping] = useState(false);
  const [message, setMessage] = useState();
  const [notifications, setNotifications] = useState([]);
  const [isEnabled, setIsEnabled] = useState(true);
  const [defaultUsers, setDefaultUsers] = useState([]);
  const [shiftBookingMappings, setShiftBookingMappings] = useState({});
  const [availableAllTimeUsers, setAvailableAllTimeUsers] = useState([]);
  const [unreadCount, setUnreadCount] = useState(() => {
    const storedUnreadCounts = localStorage.getItem("unreadCount");
    return storedUnreadCounts ? JSON.parse(storedUnreadCounts) : {};
  });
  const [socketConnected, setSocketConnected] = useState(false);

  // Use ref for audio to prevent recreation on every render
  const messageToneRef = useRef(new Audio('/audio/notification.mp3'));
  const ringtoneRef = useRef(new Audio('/audio/ringtone.mp3'));

  useEffect(() => {
    // Update localStorage whenever unreadCounts changes
    localStorage.setItem("unreadCount", JSON.stringify(unreadCount));
  }, [unreadCount]);

  // Initialize audio on first user interaction (required by browsers)
  useEffect(() => {
    const initAudio = () => {
      // Play and immediately pause to unlock audio
      messageToneRef.current.play().then(() => {
        messageToneRef.current.pause();
        messageToneRef.current.currentTime = 0;
      }).catch(() => { });

      ringtoneRef.current.play().then(() => {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
      }).catch(() => { });

      // Remove listener after first interaction
      document.removeEventListener('click', initAudio);
    };

    document.addEventListener('click', initAudio);
    return () => document.removeEventListener('click', initAudio);
  }, []);

  // console.log(user?.token);

  // const toggleCamera = () => {
  //   if (isCameraOn) {
  //     // If camera is currently on, stop the stream
  //     stream.getTracks().forEach((track) => track.stop());
  //   } else {
  //     navigator.mediaDevices.getUserMedia({ video: true, audio: true })
  //       .then((newStream) => {
  //         setStream(newStream);
  //         myVideo.current.srcObject = newStream;
  //       })
  //       .catch((error) => console.error('Error accessing camera:', error));
  //   }

  //   setIsCameraOn((prev) => !prev);
  // };

  // console.log('activeConversation',activeConversation)
  useEffect(() => {
    if (user) {
      dispatch(getByDefaultUsers());
      dispatch(getCalendarData());
      fetchLocationMappings();
    }
  }, [user, dispatch]);

  // Handle page visibility - refresh when tab becomes active after being hidden
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && user) {
        // console.log('👁️ Tab became active - refreshing conversations');
        dispatch(getConversations());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [user, dispatch]);

  const fetchLocationMappings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/location-mappings`,
        { withCredentials: true }
      );
      setShiftBookingMappings(response.data.shiftBookingToDisplayName || {});
      setAvailableAllTimeUsers(response.data.availableAllTimeUsers || []);
    } catch (error) {
      console.error('Error fetching location mappings:', error);
    }
  };


  // Use ref to track active conversation without re-triggering socket listeners
  const activeConversationRef = useRef(activeConversation);

  useEffect(() => {
    activeConversationRef.current = activeConversation;
  }, [activeConversation]);

  useEffect(() => {
    // Dispatch only once on mount
    if (user && user.token) {
      dispatch(getConversations(user.token));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (user?._id) {
      // Join user's personal room to receive notifications
      socket.emit("join", { userId: user._id, companyId: user.companyId });
      // console.log(`🔌 Joined personal room: ${user._id}`);
    }

    socket.emit("setup socket", user?._id);
    socket.on("connected", () => {
      setSocketConnected(true);
    });

    // Handle socket reconnection (critical for maintaining connection after inactivity)
    socket.on('reconnect', (attemptNumber) => {
      // console.log(`🔄 Socket reconnected after ${attemptNumber} attempts - rejoining rooms`);
      if (user?._id) {
        socket.emit("join", { userId: user._id, companyId: user.companyId });
        // console.log(`🔌 Rejoined personal room: ${user._id}`);
      }
      if (activeConversationRef.current?._id) {
        socket.emit("join conversation", activeConversationRef.current._id);
        // console.log(`💬 Rejoined conversation room: ${activeConversationRef.current._id}`);
      }
      // Refresh conversations to catch any missed messages
      dispatch(getConversations());
    });

    socket.on('disconnect', (reason) => {
      // console.warn('⚠️ Socket disconnected:', reason);
      setSocketConnected(false);
      if (reason === 'io server disconnect') {
        // Server disconnected - try to reconnect
        socket.connect();
      }
    });

    socket.on('connect_error', (error) => {
      // console.error('❌ Socket connection error:', error.message);
    });

    return () => {
      socket.off('reconnect');
      socket.off('disconnect');
      socket.off('connect_error');
    };
    // socket.on("typing", () => setIsTyping(true));
    // socket.on("stop typing", () => setIsTyping(false));
  }, [user, socket, dispatch]);

  useEffect(() => {
    if (!user?._id) return;

    // console.log('🔌 Joining user room:', user._id);
    socket.emit("join", { userId: user._id, companyId: user.companyId });

    //get online users
    const handleOnlineUsers = (users) => {
      setOnlineUsers(users);
    };

    socket.on("get-online-users", handleOnlineUsers);

    return () => {
      socket.off("get-online-users", handleOnlineUsers);
    };
  }, [user, socket]);

  // Join conversation room when activeConversation changes
  useEffect(() => {
    if (activeConversation?._id) {
      // console.log('💬 Joining conversation room:', activeConversation._id);
      socket.emit("join conversation", activeConversation._id);
    }
  }, [activeConversation, socket]);

  useEffect(() => {
    //listening to receiving a message
    const handleReceiveMessage = (message) => {
      // console.log('📩 Message received:', message);
      dispatch(updateMessagesAndConversations(message));
      messageToneRef.current.play().catch(err => console.log('Audio play failed:', err));

      // ✅ Auto-mark as seen if this conversation is currently active
      if (activeConversationRef.current?._id === message.conversation?._id) {
        // console.log('📖 Auto-marking message as seen (conversation is active)');
        // Mark as seen in database
        axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/api/conversation/seen/${message.conversation._id}`,
          { userId: user?._id },
          { withCredentials: true }
        ).catch(err => console.error('Failed to mark as seen:', err));
      }
    };

    //listening when a user is typing
    const handleTyping = (conversation) => setTyping(conversation);
    const handleStopTyping = () => setTyping(false);

    // Listen for call status updates (for caller)
    const handleCallAnswered = (data) => {
      // console.log('✅ Call answered by:', data.receiverName);
      toast.success(`${data.receiverName} answered your call`);
      setCallStatus('answered');

      // Set startTime NOW for caller since call was just accepted
      const activeCall = localStorage.getItem('activeCallLog');
      if (activeCall) {
        const callData = JSON.parse(activeCall);
        callData.startTime = Date.now(); // Start timing from acceptance
        localStorage.setItem('activeCallLog', JSON.stringify(callData));
        // console.log('⏱️ Started duration tracking for caller');
      }
    };
    const handleCallDeclined = (data) => {
      // console.log('❌ Call declined by:', data.receiverName);
      toast.error(`${data.receiverName} declined your call`);
    };

    const handleCallCancelled = () => {
      // console.log('🚫 Call cancelled by caller');
      toast.dismiss(); // Dismiss the incoming call toast
      ringtoneRef.current.pause();
      ringtoneRef.current.currentTime = 0;
    };

    // Listen for incoming call invitations
    const handleCallInvitation = (data) => {
      // console.log('📞 Incoming call from:', data.fromName);
      const callTypeText = data.callType === 'video' ? 'Video' : 'Audio';

      // Play ringtone
      ringtoneRef.current.loop = true;
      ringtoneRef.current.play().catch(err => console.log('Ringtone play failed:', err));

      toast.info(
        <div>
          <p><strong>{callTypeText} call from {data.fromName}</strong></p>
          <div className="d-flex gap-2">
            <button
              className="btn btn-success btn-sm"
              onClick={async () => {
                ringtoneRef.current.pause();
                ringtoneRef.current.currentTime = 0;

                // Store call info for duration tracking (receiver side)
                // Set startTime NOW because call is being ACCEPTED
                localStorage.setItem('activeCallLog', JSON.stringify({
                  callLogId: data.callLogId,
                  startTime: Date.now(), // Start timing from acceptance
                  isReceiver: true,
                  otherUserId: data.from,
                }));

                // Update call status to "answered" via Socket.io
                if (data.callLogId) {
                  // console.log('🔄 Updating call status to answered via Socket.io');
                  socket.emit("update call status", {
                    callLogId: data.callLogId,
                    status: 'answered',
                    callerId: data.from,
                    receiverName: user?.name || 'User',
                  });
                } else {
                  console.warn('⚠️ No callLogId received from caller');
                }

                window.open(`/room/${data.roomId}`, '_blank');
                toast.dismiss();
              }}
            >
              Accept
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={async () => {
                ringtoneRef.current.pause();
                ringtoneRef.current.currentTime = 0;

                // Update call status to "declined" via Socket.io
                if (data.callLogId) {
                  // console.log('🔄 Updating call status to declined via Socket.io');
                  socket.emit("update call status", {
                    callLogId: data.callLogId,
                    status: 'declined',
                    endTime: new Date(),
                    callerId: data.from,
                    receiverName: user?.name || 'User',
                  });
                } else {
                  console.warn('⚠️ No callLogId received from caller');
                }

                toast.dismiss();
              }}
            >
              Decline
            </button>
          </div>
        </div>,
        {
          autoClose: 30000, // 30 seconds to answer
          closeButton: false,
          onClose: () => {
            ringtoneRef.current.pause();
            ringtoneRef.current.currentTime = 0;
          }
        }
      );
    };


    // Listen for messages being marked as seen
    const handleMessagesMarkedSeen = (data) => {
      // console.log('📖 Messages marked as seen:', data);
      // Update messages in Redux to show as seen
      dispatch(markMessagesAsSeen({
        conversationId: data.conversationId
      }));
    };

    socket.on("receive message", handleReceiveMessage);
    socket.on("typing", handleTyping);
    socket.on("stop typing", handleStopTyping);
    socket.on("call invitation", handleCallInvitation);
    socket.on("call answered", handleCallAnswered);
    socket.on("call declined", handleCallDeclined);
    socket.on("call cancelled", handleCallCancelled);
    socket.on("messages marked seen", handleMessagesMarkedSeen);

    return () => {
      socket.off("receive message", handleReceiveMessage);
      socket.off("typing", handleTyping);
      socket.off("stop typing", handleStopTyping);
      socket.off("call invitation", handleCallInvitation);
      socket.off("call answered", handleCallAnswered);
      socket.off("call declined", handleCallDeclined);
      socket.off("call cancelled", handleCallCancelled);
      socket.off("messages marked seen", handleMessagesMarkedSeen);
    };
  }, [socket]); // ✅ Only re-register when socket changes, not on every dispatch

  //   const fetchCalendarData = async () => {
  //     try {
  //         const { data } = await axios.get(
  //             `${process.env.REACT_APP_BACKEND_URL}/api/users/getCalendarData`,
  //             {
  //                 headers: {
  //                     Authorization: `Bearer ${user.token}`,
  //                 },
  //             }
  //         );
  //         console.log('Fetched data:', data); // Log the fetched data
  //         setCalendarData(data);
  //     } catch (error) {
  //         console.error('Error fetching calendar data:', error);
  //     }
  // };

  // useEffect(() => {
  //         fetchCalendarData();
  // }, []);

  // useEffect(() => {
  // }, [calendarData]);
  // console.log('Calendar data updated:', shiftBookings); // Log calendarData to ensure it's being fetched correctly

  // useEffect(() => {
  //   // Event listener for receiving notifications
  //   socket.on("receive notification", (notification) => {
  //     // Update unread message count when a new notification is received

  //     setUnreadCount(notification.unreadCount);
  //   });

  //   // Clean up event listeners when component unmounts
  //   return () => {
  //     socket.off("receive notification");
  //   };
  // }, []);

  // const handleReadMessages = () => {
  //   // Emit "read messages" event to the server
  //   socket.emit("read messages", user?._id);
  //   // Reset unread message count locally
  //   setUnreadCount(0);
  // };

  function randomID(len) {
    let result = '';
    if (result) return result;
    var chars = '12345qwertyuiopasdfgh67890jklmnbvcxzMNBVCZXASDQWERTYHGFUIOLKJP',
      maxPos = chars.length,
      i;
    len = len || 5;
    for (i = 0; i < len; i++) {
      result += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return result;
  }

  // State to track current call status for cancellation handling
  const [callStatus, setCallStatus] = useState(null); // 'calling', 'answered', 'declined', 'ended'
  const callWindowRef = useRef(null);

  // Direct call using room-based approach (no ZIM required)
  const videoCall = async () => {
    // console.log('📹 Initiating video call');
    setCallStatus('calling');

    // Generate unique room ID for this call
    const roomId = `call_${user._id}_${getConversationId(user, activeConversation.users)}_${Date.now()}`;
    const receiverId = getConversationId(user, activeConversation.users);

    let callLogId = null;

    // Create call log in database
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/calllogs`,
        {
          receiver: receiverId,
          callType: 'video',
          roomId: roomId,
          conversationId: activeConversation._id,
        },
        { withCredentials: true }
      );

      callLogId = response.data._id;

      // Store callLogId but NOT startTime yet - will be set when call is ACCEPTED
      localStorage.setItem('activeCallLog', JSON.stringify({
        callLogId,
        otherUserId: receiverId,
      }));

      // console.log(' Call log created:', callLogId);
    } catch (error) {
      // console.error('Failed to create call log:', error);
    }

    // Notify other user via Socket.io (include callLogId)
    socket.emit("call invitation", {
      to: receiverId,
      from: user._id,
      fromName: user.name,
      roomId: roomId,
      callType: 'video',
      callLogId: callLogId, // Send callLogId to receiver
    });

    // Open call room in new window
    const newWindow = window.open(`/room/${roomId}`, '_blank');
    callWindowRef.current = newWindow;
    toast.success('Call started! Opening in new window...');

    // Monitor window close to cancel call if not answered
    const checkWindowClosed = setInterval(() => {
      if (newWindow.closed) {
        clearInterval(checkWindowClosed);
        // If window closed and call is still in 'calling' state (not answered/declined)
        // We can't easily access the *current* state value inside interval closure without ref or functional update
        // But we can check if we should emit cancel
        // A safer way is to emit 'cancel call' if we haven't received 'answered' event.
        // We'll rely on a ref for status to be safe in interval
        if (callStatusRef.current === 'calling') {
          // console.log(' Call window closed by caller before answer - cancelling call');
          socket.emit("cancel call", { to: receiverId });
        }
      }
    }, 1000);
  };

  // Ref to track status inside interval
  const callStatusRef = useRef(null);
  useEffect(() => {
    callStatusRef.current = callStatus;
  }, [callStatus]);

  const audioCall = async () => {
    // console.log('📞 Initiating audio call');
    setCallStatus('calling');

    // Generate unique room ID for this call
    const roomId = `call_${user._id}_${getConversationId(user, activeConversation.users)}_${Date.now()}`;
    const receiverId = getConversationId(user, activeConversation.users);

    let callLogId = null;

    // Create call log in database
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/calllogs`,
        {
          receiver: receiverId,
          callType: 'audio',
          roomId: roomId,
          conversationId: activeConversation._id,
        },
        { withCredentials: true }
      );

      callLogId = response.data._id;

      // Store callLogId but NOT startTime yet - will be set when call is ACCEPTED
      localStorage.setItem('activeCallLog', JSON.stringify({
        callLogId,
        otherUserId: receiverId,
      }));

      // console.log(' Call log created:', callLogId);
    } catch (error) {
      // console.error('Failed to create call log:', error);
    }

    // Notify other user via Socket.io (include callLogId)
    socket.emit("call invitation", {
      to: receiverId,
      from: user._id,
      fromName: user.name,
      roomId: roomId,
      callType: 'audio',
      callLogId: callLogId, // Send callLogId to receiver
    });

    // Open call room in new window
    const newWindow = window.open(`/room/${roomId}`, '_blank');
    callWindowRef.current = newWindow;
    toast.success('Call started! Opening in new window...');

    // Monitor window close
    const checkWindowClosed = setInterval(() => {
      if (newWindow.closed) {
        clearInterval(checkWindowClosed);
        if (callStatusRef.current === 'calling') {
          // console.log(' Call window closed by caller before answer - cancelling call');
          socket.emit("cancel call", { to: receiverId });
        }
      }
    }, 1000);
  };

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const shouldShowDefaultUser = (userId) => {
      // Unified date comparison that works year-round (handles BST/GMT automatically)
      const currentDate = new Date();
      const today = currentDate.toISOString().split('T')[0];

      let isUserEnabled = false;
      const defaultUsersSet = new Set();
      let locationMatchFound = false;

      // Wait for mappings to load before processing
      if (!shiftBookingMappings || Object.keys(shiftBookingMappings).length === 0) {
        // console.log('⏳ Waiting for location mappings to load...');
        return false;
      }

      // Iterate through shiftBookings
      for (const bookingData of shiftBookings) {
        // Only consider bookings for today
        const bookingDate = new Date(bookingData.date).toISOString().split('T')[0];
        if (bookingDate !== today) continue;

        // Find bookings for this specific student
        const studentBookings = (bookingData.bookings && bookingData.bookings.filter(b =>
          b.student?.toString() === userId?.toString() && b.status === "Active"
        )) || [];

        if (studentBookings.length > 0) {
          isUserEnabled = true;
          const locationId = bookingData.location;

          studentBookings.forEach(booking => {
            const shiftId = booking.shift;
            const compositeKey = `${locationId}_${shiftId}`;
            const displayName = shiftBookingMappings[compositeKey];

            if (displayName) {
              defaultUsersSet.add(displayName.toString());
              locationMatchFound = true;
            }
          });
        }
      }

      // console.log(`📋 Final defaultUsersSet:`, Array.from(defaultUsersSet));
      // console.log(`📊 shiftBookingMappings:`, shiftBookingMappings);

      // ALWAYS include specialized "Available All Time" users (e.g., Support, Helpdesk)
      if (availableAllTimeUsers.length > 0) {
        availableAllTimeUsers.forEach(userId => {
          defaultUsersSet.add(userId.toString());
        });
        // Remove global override: chat is only enabled if student has a shift
        // isUserEnabled = true; 
      }

      const filteredUsers = users.filter(user => {
        return defaultUsersSet.has(user._id?.toString());
      });

      setIsEnabled(isUserEnabled);
      setDefaultUsers(filteredUsers);

      return isUserEnabled;
    };

    const isStudent = user?.type === 'student';
    if (isStudent) {
      shouldShowDefaultUser(user._id);
    } else {
      setIsEnabled(true);
    }

    /*if (user) {
  shouldShowDefaultUser(user._id);
  }*/

  }, [user, users, shiftBookings, availableAllTimeUsers, shiftBookingMappings]);

  return (
    <>
      <div className="main">
        <div className="mainContainer">
          <Sidebar
            onlineUsers={onlineUsers}
            typing={typing}
            isHidden={isHidden}
            setIsHidden={setIsHidden}
            unreadCount={unreadCount}
            setUnreadCount={setUnreadCount}
            defaultUsers={defaultUsers}
          />
          {activeConversation?._id ? (
            <ChatContainer
              onlineUsers={onlineUsers}
              typing={typing}
              videoCall={videoCall}
              audioCall={audioCall}
              isHidden={isHidden}
              setIsHidden={setIsHidden}
              isEnabled={isEnabled}
              defaultUsers={defaultUsers}
              availableAllTimeUsers={availableAllTimeUsers}
            />
          ) : (
            <KbmChatHome />
          )}
        </div>
      </div>
    </>
  )
}

const HomeWithSocket = (props) => (
  <SocketContext.Consumer>
    {(socket) => <Home {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default HomeWithSocket